import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL;

/** Shared axios instance — auth + subscription interceptors wired in AxiosInterceptorSetup (B4.3). */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export function assertApiUrlConfigured() {
  if (!API_BASE_URL) {
    throw new Error(
      'API URL is not configured. Set REACT_APP_API_URL in .env.development (e.g. https://localhost:7177/api).'
    );
  }
}

export default apiClient;
